import GET_CATEGORIES from "../plugins/getCategories"

const [ w, d, l, content ] = [ window, document, location, location.pathname.replace(/^\/([^/]+)\//,'$1') ]

const replace_item = () => {
  $('.contents .wrapLink','.element_list').each( (i,obj) => {
    let href = obj.getAttribute('href')
    let thumb = obj.querySelector('.thum_img > img').getAttribute('src')
    let is_new = obj.querySelectorAll('span.new').length > 0 ? true: false
    let catObj = obj.querySelector('.catetitle a')
    let cat = catObj? catObj.innerText : ''
    let dateObj = obj.querySelector('p.date')
    let date = dateObj? dateObj.innerText : false
    let title = obj.querySelector('h5 > a').getAttribute('title')
    let desc = obj.querySelector('p.catch').innerText
    $(obj).replaceWith(`
    <a class="${content}-item" href="${href}">
      <figure class="${content}-item__img">
        <div class="${content}-item__img-cover" style="background-image:url( ${thumb} )">
          <img src="${thumb}" width="200">
        </div>
        ${(catObj)? `<span class="cate">${cat}</span>`: '' }
      </figure>
      <div class="${content}-item__body">
        <h4 class="subject">
          ${title}
          ${is_new ? '<span class="new">NEW</span>': ''}
        </h4>
        ${(date)? `<small class="date">${date}</small>`: ''}
      </div>
    </a>
    `)
  })
}


const detail_init = async the_id => {

  // 全記事取得
  let articles = await $.getArticles({ content })
  let categories = await $.getCategories({ content })
  let the_article = articles.filter( a => (a.id == the_id) ).shift()
  the_article.category = categories.filter( c => c.id == the_article.category )[0]

  let $head = $(`
    <div class="${content}-detail__head">
      ${the_article.category.name ? `<span class="cat">${the_article.category.name}</span>`: '' }
      <h3 class="title">${the_article.title}</h3>
      ${the_article.desc.length ? `<p class="desc">${the_article.desc}</p>`: '' }
    </div>
  `)
  $('.element_detail > .title, .detail_title').remove()
  $head.prependTo('.element_detail')
  $('#main .detailfooter').appendTo('#container')

}

const init = () => {

  $('.element_list .list_title1').remove()
  replace_item()

  // サイドカラムのサムネイル画像差し替え
  $('.artloop .thum_img img', '#side').each( (i, obj) => {
    obj.src = obj.src.replace(/\/thumb-/,'/')
  })

  // カテゴリ一覧取得
  $(`.${content}-catelist`).insertAfter('.breadcrumbs')
  GET_CATEGORIES(`.${content}-catelist[data-plugin="getCategories"]`).then( (obj,container) => {
    let cats = container.querySelectorAll('.cat');
    let tglBtn = $(`<button class="button button-text"><span>すべてのカテゴリを見る</span> <i class="" aria-hidden="true">+</i></button>`);
    tglBtn.on('click', function() {
      const $btn = $(this);
      const $container = $(container);

      $('.is-short', $container).fadeToggle(200)
      $btn.toggleClass('is-active');
      $container.toggleClass('is-active');

      const btnhtml = $btn.hasClass('is-active') ? `<span>一部のカテゴリのみ表示</span> <i class="" aria-hidden="true">-</i>`: `<span>すべてのカテゴリを見る</span> <i class="" aria-hidden="true">+</i>`;
      $btn.html( btnhtml );
    });
    cats.forEach( (element,i) => {
      if(i >= 7) {
        element.classList.add('is-short');
        element.style.display="none";
      }
    });
    if( cats.length >= 7 ) $(container).append( tglBtn );
    
  });

}

export default function CUSTOM () {
  $(() => {
    init()
    if( w.query_string('article') ) detail_init( w.query_string('article') )
  })
}